import { LoyaltyRoutesPath } from '../interfaces/loyalty.interface';

interface LinkedMenuItem<T> {
  link?: string;
  items?: T[];
}

const MANAGE_AVIOS_LINK = new RegExp(
  `^(?:https?://[^/]+)?(?:/[^/?#]+)?/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.MANAGE_AVIOS}/?(?:[?#].*)?$`,
  'i'
);

export const isManageAviosLink = (link?: string): boolean => !!link && MANAGE_AVIOS_LINK.test(link.trim());

/**
 * Drops Manage Avios links, nested ones included, unless `showManageAvios` is true. Callers pass
 * `enableBoostAvios && !isJuniorMember`: every environment reads the same CMS, and no CMS fragment
 * can tell a junior from an adult on the same tier, so the decision is made in code.
 *
 * TODO: when the `enableBoostAvios` flag goes, callers keep passing `!isJuniorMember`.
 */
export const filterManageAviosLinks = <T extends LinkedMenuItem<T>>(items: T[], showManageAvios: boolean): T[] => {
  if (showManageAvios || !items) {
    return items;
  }
  return items
    .filter(({ link }) => !isManageAviosLink(link))
    .map((item) => (item.items ? { ...item, items: filterManageAviosLinks(item.items, showManageAvios) } : item));
};
